"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recentlyDeletedMatchListQuerySchema = exports.RECENTLY_DELETED_MATCH_MAX_CUTOFF_DAYS = exports.RECENTLY_DELETED_MATCH_DEFAULT_CUTOFF_DAYS = exports.recentlyDeletedMatchListResponseSchema = exports.recentlyDeletedMatchSchema = void 0;
const zod_1 = require("zod");
const approval_rules_1 = require("./approval-rules");
exports.recentlyDeletedMatchSchema = zod_1.z.object({
    snapshot_id: zod_1.z.string(),
    approval_request_id: zod_1.z.string().uuid().nullable(),
    buy_ticket_ref: zod_1.z.string().nullable(),
    sell_ticket_ref: zod_1.z.string().nullable(),
    allocated_quantity_mt: zod_1.z.string().nullable(),
    margin_mt: zod_1.z.string().nullable(),
    currency: zod_1.z.string().nullable(),
    rejecting_role: approval_rules_1.pgApproverRoleSchema.nullable(),
    rejecting_comment: zod_1.z.string().nullable(),
    deleted_at: zod_1.z.string(),
});
exports.recentlyDeletedMatchListResponseSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.recentlyDeletedMatchSchema),
    cutoff_days: zod_1.z.number().int().positive(),
    count: zod_1.z.number().int().nonnegative(),
});
exports.RECENTLY_DELETED_MATCH_DEFAULT_CUTOFF_DAYS = 30;
exports.RECENTLY_DELETED_MATCH_MAX_CUTOFF_DAYS = 365;
exports.recentlyDeletedMatchListQuerySchema = zod_1.z.object({
    cutoffDays: zod_1.z.coerce
        .number()
        .int()
        .positive()
        .max(exports.RECENTLY_DELETED_MATCH_MAX_CUTOFF_DAYS)
        .default(exports.RECENTLY_DELETED_MATCH_DEFAULT_CUTOFF_DAYS),
});
//# sourceMappingURL=inventory-match-approvals.js.map